export default "__VITE_ASSET__zBojWgPT__"